export default {
    ...window.env,
    FILE_PUBLIC_HOST: 'https://read-public-resources.oss-cn-shenzhen.aliyuncs.com/',
}